import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("调用明细")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("    ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("导出")

import {ref, onMounted, reactive, watch, computed} from "vue";
import { useStore } from "vuex";
import Datatable from "@/components/kt-datatable/Datatable3.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  filters: Object,
},
  setup(__props) {

const props = __props



const store = useStore();

const defaultSort = ref('-id');

const dataT = ref<HTMLElement | null>(null);
const apiUrl = 'm/api';
const tableHeader = ref([
  { name: "日期", key: "dt", width: 200, sortable: true },
  { name: "平台", key: "platform", sortable: true },
  { name: "API", key: "api", sortable: true },
  { name: "调用量", key: "cnt", sortable: true },
]);
const filters = reactive(props.filters as any);

const user = computed(() => store.getters.currentUser);
const currentSite = computed(() => {
  if (user.value && user.value.sites && user.value.site_id) {
    const site = user.value.sites.find(s => s.id === user.value.site_id);
    return site ? site.name : '';
  }
  return '';
});

onMounted(() => {
});

watch(filters, (val) => {
  if ((dataT as any).value.loading === false){
    (dataT as any).value.setCurrent(1);
  }
});

// 导出
const toExcel = () => {
  const siteName = currentSite.value || 'data';
  const startDate = (filters.start_date || '').replace(/-/g, '');
  const stopDate = (filters.stop_date || '').replace(/-/g, '');
  const fileName = `${siteName}_${startDate}_${stopDate}`;
  
  (dataT as any).value.toExcel(['dt', 'platform', 'api', 'cnt'], fileName, ['日期', '平台', 'API', '调用量'])
};

const nl2br = function (str) {
  return str.replace(/[\r\n]/g,'<br>');
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createBlock(Datatable, {
    ref_key: "dataT",
    ref: dataT,
    apiUrl: apiUrl,
    "table-header": tableHeader.value,
    "enable-items-per-page-dropdown": true,
    filters: _unref(filters),
    title: "操作记录",
    "default-sort": defaultSort.value,
    actionMenu: false
  }, {
    search: _withCtx(() => [
      _hoisted_1
    ]),
    toolbar: _withCtx(() => [
      _hoisted_2,
      _createVNode(_component_el_button, {
        type: "primary",
        icon: "el-icon-document",
        size: "small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toExcel()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["table-header", "filters", "default-sort"]))
}
}

})